import { forwardRef, useEffect, useImperativeHandle, useRef, useState } from 'react';
import { RequiredMarker } from '../forms/FieldLabel';

const HumanVerification = forwardRef(function HumanVerification({ siteKey, onVerified }, ref) {
  const container = useRef(null);
  const widget = useRef(null);
  const [failed, setFailed] = useState(false);
  useImperativeHandle(ref, () => ({
    token: () => widget.current === null ? '' : window.hcaptcha?.getResponse(widget.current) || '',
    reset: () => { if (widget.current !== null) window.hcaptcha?.reset(widget.current); onVerified?.(false); },
  }), [onVerified]);
  useEffect(() => {
    if (!siteKey) return;
    let attempts = 0;
    const render = () => {
      if (window.hcaptcha?.render && container.current && widget.current === null) {
        widget.current = window.hcaptcha.render(container.current, {
          sitekey: siteKey,
          callback: () => onVerified?.(true),
          'expired-callback': () => onVerified?.(false),
          'error-callback': () => onVerified?.(false),
        });
        return true;
      }
      return widget.current !== null;
    };
    if (!document.querySelector('script[src*="hcaptcha.com/1/api.js"]')) {
      const script = document.createElement('script');
      script.src = 'https://js.hcaptcha.com/1/api.js?render=explicit&recaptchacompat=off';
      script.async = true; document.body.appendChild(script);
    }
    const timer = window.setInterval(() => {
      if (render()) window.clearInterval(timer);
      else if (++attempts >= 150) { setFailed(true); window.clearInterval(timer); }
    }, 100);
    render();
    return () => { window.clearInterval(timer); if (widget.current !== null) { window.hcaptcha?.remove(widget.current); widget.current = null; } };
  }, [siteKey, onVerified]);
  return <div className="lesson-verification">{siteKey && <p>Human verification<RequiredMarker /></p>}<div ref={container} />{failed && <p role="alert">Verification could not load. Please reload the page to try again.</p>}</div>;
});
export default HumanVerification;
